import { createSlice, createAction } from "@reduxjs/toolkit";
import {
	Staff,
	StaffQueryParams,
	DataChangePass,
	STAFF_STATUS,
} from "../types";
import { RootState } from "store/store";
import { USER_TYPE, GENDER } from "types";

interface StaffState {
  staffList: Array<Staff>;
  staffTotal: number;
  staffDetail: Staff;
}

export const staffDefault: Staff = {
	id: 0,
	fullName: "",
	gender: GENDER.MALE,
	avatar: "",
	birthday: "",
	phoneNumber: "",
	email: "",
	idCard: "",
	address: "",
	status: STAFF_STATUS.ENABLE,
	roles: [],
	username: "",
	userType: USER_TYPE.STAFF,
};

const initialState: StaffState = {
	staffList: [],
	staffTotal: 0,
	staffDetail: staffDefault,
};

export const staffSlice = createSlice({
	name: "staff",
	initialState,
	reducers: {
		setListStaff: (state, action) => {
			state.staffList = action.payload.data;
			state.staffTotal = action.payload.total;
		},
		setDetailStaff: (state, action) => {
			state.staffDetail = action.payload.data;
		},
		resetDetailStaff: (state) => {
			state.staffDetail = staffDefault;
		},
		changeStatusStaff: (state, action) => {
			const { id, status } = action.payload;
			const index = state.staffList.findIndex(el => el.id === id);
			state.staffList[index].status = status;
		},
	},
});

export const selectStaffList = (state: RootState) => state.staff.staffList;
export const selectStaffTotal = (state: RootState) => state.staff.staffTotal;
export const selectStaffDetail = (state: RootState) => state.staff.staffDetail;

export const { setListStaff, setDetailStaff, changeStatusStaff, resetDetailStaff } =
  staffSlice.actions;

export interface GetListStaffAsyncPayload {
  query: StaffQueryParams;
	callback?: () => void;
}
export const getListStaffAsync = createAction(
	"staff/getListStaffAsync",
	(payload: GetListStaffAsyncPayload) => ({
		payload: payload || {},
	}),
);

export interface GetDetailStaffAsyncPayload {
  id: number;
}
export const getDetailStaffAsync = createAction(
	"staff/getDetailStaffAsync",
	(payload: GetDetailStaffAsyncPayload) => ({
		payload,
	}),
);

export interface CreateStaffAsyncPayload {
  data: Staff;
  returnStatus: Function;
}
export const createStaffAsync = createAction(
	"staff/createStaffAsync",
	(payload: CreateStaffAsyncPayload) => ({
		payload,
	}),
);

export interface UpdateStaffAsyncPayload {
  data: Staff;
  id: number;
  myProfileId: number;
	callback?: () => void;
}
export const updateStaffAsync = createAction(
	"staff/updateStaffAsync",
	(payload: UpdateStaffAsyncPayload) => ({
		payload,
	}),
);

export interface ChangePassStaffAsyncPayload {
  data: DataChangePass;
  returnResult: (arg: boolean) => void;
}

export const changePassStaffAsync = createAction(
	"staff/changePassStaffAsync",
	(payload: ChangePassStaffAsyncPayload) => ({
		payload,
	}),
);

export default staffSlice.reducer;
